import { STORE_FEATURE_FLAGS } from '../constants/actionTypes'

export const storeFlags = flags => {
  return {
    type: STORE_FEATURE_FLAGS,
    flags,
  }
}
